import { Menu } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { Pages } from '../routing/pages';

const sidebarMenuItems = [
  {
    key: Pages.CONFIGURATION.children.LANDING.link,
    label: Pages.CONFIGURATION.children.LANDING.label,
  },
  {
    key: Pages.CONFIGURATION.children.JOB_CLASSIFICATION.path,
    label: Pages.CONFIGURATION.children.JOB_CLASSIFICATION.label,
    children: [
      {
        key: Pages.CONFIGURATION.children.JOB_CLASSIFICATION.children.STRUCTURE.link,
        label: Pages.CONFIGURATION.children.JOB_CLASSIFICATION.children.STRUCTURE.label,
      },
      {
        key: Pages.CONFIGURATION.children.JOB_CLASSIFICATION.children.JOB_LEVELS.link,
        label: Pages.CONFIGURATION.children.JOB_CLASSIFICATION.children.JOB_LEVELS.label,
      },
      {
        key: Pages.CONFIGURATION.children.JOB_CLASSIFICATION.children.JOB_CLASSIFICATION_CODES.link,
        label: Pages.CONFIGURATION.children.JOB_CLASSIFICATION.children.JOB_CLASSIFICATION_CODES.label,
      },
      {
        key: Pages.CONFIGURATION.children.JOB_CLASSIFICATION.children.JOB_FAMILIES.link,
        label: Pages.CONFIGURATION.children.JOB_CLASSIFICATION.children.JOB_FAMILIES.label,
      },
      {
        key: Pages.CONFIGURATION.children.JOB_CLASSIFICATION.children.SKILL_TYPES.link,
        label: Pages.CONFIGURATION.children.JOB_CLASSIFICATION.children.SKILL_TYPES.label,
      },
      {
        key: Pages.CONFIGURATION.children.JOB_CLASSIFICATION.children.SKILL_CLUSTERS.link,
        label: Pages.CONFIGURATION.children.JOB_CLASSIFICATION.children.SKILL_CLUSTERS.label,
      },
      {
        key: Pages.CONFIGURATION.children.JOB_CLASSIFICATION.children.SKILL_LEVELS.link,
        label: Pages.CONFIGURATION.children.JOB_CLASSIFICATION.children.SKILL_LEVELS.label,
      },
      {
        key: Pages.CONFIGURATION.children.JOB_CLASSIFICATION.children.SKILLS.link,
        label: Pages.CONFIGURATION.children.JOB_CLASSIFICATION.children.SKILLS.label,
      },
      {
        key: Pages.CONFIGURATION.children.JOB_CLASSIFICATION.children.COMPETENCIES.link,
        label: Pages.CONFIGURATION.children.JOB_CLASSIFICATION.children.COMPETENCIES.label,
      },
      {
        key: Pages.CONFIGURATION.children.JOB_CLASSIFICATION.children.MAPPINGS.path,
        label: Pages.CONFIGURATION.children.JOB_CLASSIFICATION.children.MAPPINGS.label,
        children: [
          {
            key: Pages.CONFIGURATION.children.JOB_CLASSIFICATION.children.MAPPINGS.children.JOB_FAMILY_COMPETENCY.link,
            label:
              Pages.CONFIGURATION.children.JOB_CLASSIFICATION.children.MAPPINGS.children.JOB_FAMILY_COMPETENCY.label,
          },
          {
            key: Pages.CONFIGURATION.children.JOB_CLASSIFICATION.children.MAPPINGS.children.JOB_CLASSIFICATION_SKILL
              .link,
            label:
              Pages.CONFIGURATION.children.JOB_CLASSIFICATION.children.MAPPINGS.children.JOB_CLASSIFICATION_SKILL.label,
          },
        ],
      },
    ],
  },
  {
    key: Pages.CONFIGURATION.children.API_CONFIGURATION.path,
    label: Pages.CONFIGURATION.children.API_CONFIGURATION.label,
    children: [
      {
        key: Pages.CONFIGURATION.children.API_CONFIGURATION.children.AI_CONFIGURATION.link,
        label: Pages.CONFIGURATION.children.API_CONFIGURATION.children.AI_CONFIGURATION.label,
      },
      {
        key: Pages.CONFIGURATION.children.API_CONFIGURATION.children.SF_CONFIGURATION.link,
        label: Pages.CONFIGURATION.children.API_CONFIGURATION.children.SF_CONFIGURATION.label,
      },
    ],
  },
  {
    key: Pages.CONFIGURATION.children.AI_PROMPTS.link,
    label: Pages.CONFIGURATION.children.AI_PROMPTS.label,
  },
  {
    key: Pages.CONFIGURATION.children.FIELD_MAPPINGS.link,
    label: Pages.CONFIGURATION.children.FIELD_MAPPINGS.label,
  },
  {
    key: Pages.CONFIGURATION.children.COUNTRY_CODES.link,
    label: Pages.CONFIGURATION.children.COUNTRY_CODES.label,
  },
];

export const ConfigurationSideBarNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleMenuClick = ({ key }: { key: string }) => {
    // Only navigate if it's a valid route (starts with /)
    if (key.startsWith('/')) {
      navigate(key);
    }
  };

  const getSelectedKeys = () => {
    const path = location.pathname;
    const keys: string[] = [path];

    // Also select parent keys for nested routes
    if (path.startsWith(Pages.CONFIGURATION.children.JOB_CLASSIFICATION.link)) {
      keys.push(Pages.CONFIGURATION.children.JOB_CLASSIFICATION.path);
      if (path.includes(`/${Pages.CONFIGURATION.children.JOB_CLASSIFICATION.children.MAPPINGS.path}/`)) {
        keys.push(Pages.CONFIGURATION.children.JOB_CLASSIFICATION.children.MAPPINGS.path);
      }
    }
    if (path.startsWith(Pages.CONFIGURATION.children.API_CONFIGURATION.link)) {
      keys.push(Pages.CONFIGURATION.children.API_CONFIGURATION.path);
    }

    return keys;
  };

  return (
    <Menu
      mode='inline'
      selectedKeys={getSelectedKeys()}
      items={sidebarMenuItems}
      onClick={handleMenuClick}
      className='h-full border-r-0'
    />
  );
};
